<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Définition",
          id: "definition",
          text: `La vision est essentielle au bon développement des apprentissages des enfants. Tout au long de la scolarité, il est indispensable de s’assurer de la bonne qualité de leur vision. Même si l’enfant voit net de chaque œil, il faut que son cerveau apprenne également à analyser et utiliser correctement les informations visuelles perçues. 
Toute anomalie visuelle doit être dépistée et traitée précocement.
`
        },
        {
          title: "Symptômes",
          id: "symptome",
          text: `20% de la population présente des troubles de la vision qui peuvent provoquer une gêne dans le quotidien (fatigue visuelle, maux de tête, difficultés de concentration, maladresse…) et dans leurs apprentissages scolaires ( difficultés de suivi de lignes, sauts de lignes, sauts de mots, lenteur en lecture et écriture, copie coûteuse, graphisme gros et peu régulier...).`
        },
        {
          title: "Traitement",
          id: "traitement",
          text: `Il y a parfois besoin de rééducation orthoptique pour traiter les troubles oculaires et mettre en place de meilleurs stratégies d’exploration visuelle.
          [Questionnaire de suivi ou de reprise de traitement orthoptique](/questionnaires/questionnaire_debut_reprise_suivi_orthoptique.doc)`
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>